// Meta Pixel — Borracha de Roupa (único ID válido)
export const META_PIXEL_ID = '1133860139314522';

const recentEvents = new Map();

function dedupe(key, windowMs = 2500) {
  const now = Date.now();
  const last = recentEvents.get(key) || 0;
  if (now - last < windowMs) return true;
  recentEvents.set(key, now);
  return false;
}

function ensureFbq() {
  if (typeof window === 'undefined') return false;
  return typeof window.fbq === 'function';
}

/**
 * Inicializa o pixel uma única vez.
 * Se o snippet base já rodou no index.html, só garante PageView uma vez.
 */
export function initMetaPixel() {
  if (typeof window === 'undefined') return;

  if (window.__metaPixelReady && ensureFbq()) {
    return;
  }

  if (!ensureFbq()) {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        if (n.callMethod) {
          n.callMethod.apply(n, arguments);
        } else {
          n.queue.push(arguments);
        }
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('init', META_PIXEL_ID);
  }

  if (!window.__metaPixelPageViewSent) {
    window.fbq('track', 'PageView');
    window.__metaPixelPageViewSent = true;
  }

  window.__metaPixelReady = true;
}

export function trackEvent(eventName, parameters = {}) {
  if (!ensureFbq()) return;
  window.fbq('track', eventName, parameters);
}

export function trackPurchase(value, currency = 'BRL', contentIds = []) {
  if (!ensureFbq()) return;
  const ids = (contentIds || []).map(String);
  window.fbq('track', 'Purchase', {
    value: Number(value) || 0,
    currency,
    content_ids: ids,
    content_type: 'product',
  });
}

export function trackViewContent(contentId, contentType = 'product', extra = {}) {
  if (!ensureFbq()) return;

  const id = String(contentId);
  const key = `ViewContent:${id}:${contentType}`;
  if (dedupe(key)) return;

  const params = {
    content_ids: [id],
    content_type: contentType === 'page' ? 'product' : contentType,
    content_name: extra.content_name || id,
    ...extra,
  };

  // Páginas / conteúdos sem preço: value 0 + BRL reduz aviso do Helper
  if (params.value === undefined) {
    params.value = 0;
    params.currency = params.currency || 'BRL';
  }

  window.fbq('track', 'ViewContent', params);
}

export function trackAddToCart(value, currency = 'BRL', contentId = 'vip_upgrade') {
  if (!ensureFbq()) return;
  window.fbq('track', 'AddToCart', {
    value: Number(value) || 0,
    currency,
    content_ids: [String(contentId)],
    content_type: 'product',
  });
}

export function trackInitiateCheckout(value, currency = 'BRL', contentIds = []) {
  if (!ensureFbq()) return;
  window.fbq('track', 'InitiateCheckout', {
    value: Number(value) || 0,
    currency,
    content_ids: (contentIds || []).map(String),
    content_type: 'product',
  });
}

export function trackCompleteRegistration() {
  if (!ensureFbq()) return;
  window.fbq('track', 'CompleteRegistration');
}

export function trackLogin() {
  if (!ensureFbq()) return;
  // Login não é evento padrão do Meta — usa custom
  window.fbq('trackCustom', 'Login');
}

export function trackUploadImage() {
  trackViewContent('image_upload', 'product', { content_name: 'image_upload' });
}
